import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import StyledContainer from '../../ui-library/styled/StyledContainer';

const StyledWrapper = styled.div`
  background-color: #28261b;

  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #fffef4;
  letter-spacing: 0.5px;
  text-align: left;

  width: 100%;

  min-height: 60px;
  padding-top: 4px;
`;
const StyledRightContent = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 32px;
`;
const StyledLink = styled(Link)`
  color: #fffef4;
  :hover {
    color: #fffef4;
  }
`;
const BottomBar = () => {
  return (
    <StyledWrapper>
      <StyledContainer>
        <Row>
          <Col>
            <div>&#169; 2021 AskOkey. All rights reserved</div>
          </Col>
          <Col>
            <StyledRightContent>
              <StyledLink to='/privacy-policy'>Privacy Policy</StyledLink>
              <StyledLink to='/terms-of-service'>Terms of Service</StyledLink>
            </StyledRightContent>
          </Col>
        </Row>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default BottomBar;
